import server from "@grassrootly/api/providers/supabase-provider/Server";
import withErrorCheck from "../CheckError";
import { GetMonthlyStatsPayload } from '@grassrootly/api/gateways/stats/GetMonthlyStats';
import { IStatistic } from '@grassrootly/api/entities/IStatistic';

export const GetMonthlyStats = async (params: GetMonthlyStatsPayload): Promise<IStatistic> => {
  if (!params.playerId) {
    return {
      ...params,
      groupId: 0,
      players: []
    };
  }
  const groupMappers = withErrorCheck(
    await server.from("GroupPlayers").select("group_id").eq("player_id", params.playerId)
  );
  if (!groupMappers || !groupMappers.length) {
    return {
      ...params,
      groupId: 0,
      players: []
    };
  }
  const players = withErrorCheck(await server.from("monthlystatsview")
    .select("*")
    .eq("group_id", groupMappers[0].group_id)
    .eq("month", params.month)
    .eq("year", params.year)
    .order("points", { ascending: false }));

  return {
    ...params,
    groupId: groupMappers[0].group_id,
    players,
  };
};
